export enum PaymentReportField
{
  None,
  Date,
  User,
  Pos,
  PaymentType,
  Quantity,
  Received,
  Change,
  Amount
}

export const PaymentReportFieldLabel = new Map<number, string>([
  [PaymentReportField.None, 'None'],
  [PaymentReportField.Date, 'Date Received'],
  [PaymentReportField.User, 'User'],
  [PaymentReportField.Pos, 'Pos'],
  [PaymentReportField.PaymentType, 'Payment Type'],
  [PaymentReportField.Quantity, 'Quantity'],
  [PaymentReportField.Received, 'Received'],
  [PaymentReportField.Change, 'Change'],
  [PaymentReportField.Amount, 'Amount']
]);
